import * as React from 'react';

export interface VisibilityContextState {
  register: (name: string) => void;
  toggle: (name: string, source?: boolean) => void;
  isVisible: (name: string) => boolean;
  visible: string[];
  userSetVisibility: string[];
  isUserPreferenceVisible: (name: string) => boolean;
}

export const VisibilityContext = React.createContext<VisibilityContextState>({
  register: () => {
    console.error('noContextFound');
  },
  toggle: () => {
    console.error('noContextFound');
  },
  isVisible: () => {
    console.error('noContextFound');
    return false;
  },
  isUserPreferenceVisible: () => {
    console.error('noContextFound');
    return false;
  },
  visible: [],
  userSetVisibility: [],
});
